import { ref } from 'vue'
import { trim, replacePath } from '@/util/Util'
import apiURL from '@/bis/data/commonApi'

const SERVER_URL = process.env.VUE_APP_BASE_URL;

const commonApi = (LoginAuthStore) => {
  const headersMap = {
    'Content-Type': 'application/json',
    'X-AUTH-TOKEN': LoginAuthStore.accessToken
  }
  const passwdRef = ref('')
  const errorRef = ref({})
  const checkRes = ref();
  const pictureRef = ref({})
  const checkPwd = async () => {
    const pwd = trim(passwdRef.value)
    const query = `?pwd=${pwd}`
    const url = replacePath(apiURL.checkPwd.api);

    fetch(`${SERVER_URL}${apiURL.baseUri}${url}${query}`,
    {
      method: apiURL.checkPwd.method,
      headers: headersMap,
    }).then(res => res.json())
    .then(res => {
      if (res.success) {
        console.log(res)
        passwdRef.value = ''
        checkRes.value = res;
        return res;
      } else {
        checkRes.value = res;
        errorRef.value.message = res.error.msg
        LoginAuthStore.redirectInvalidSession(res)
      }
    }).catch(err => {
      checkRes.value = err;
      errorRef.value.message = err.message
      console.error(err)
    })


    // 개선 검토
    /*
    try {
      const res = fetch(`${SERVER_URL}${apiURL.baseUri}${url}${query}`, {
        method: apiURL.checkPwd.method,
        headers: headersMap,
      })

      if (!res.ok) {
        // 서버가 응답했지만 상태 코드가 200이 아님
      }

      const data = await res.json()

      if (data.success) {
        console.log(data)
        passwdRef.value = ''
        checkRes.value = data;
        return data;
      } else {
        checkRes.value = data;
        errorRef.value.message = data.error.msg
        LoginAuthStore.redirectInvalidSession(data)
      }

    } catch (err) {
      // 서버 offline, 네트워크 오류, fetch 실패 등
      checkRes.value = err
      errorRef.value.message = err.message // '서버에 연결할 수 없습니다. 네트워크 상태를 확인하세요.'
      console.error(err)
      // console.error('Network or server error:', err)
    }
    */

  }

  const loadCommonCode = async (code) => {
    const result = fetch(`${SERVER_URL}${apiURL.baseUri}${replacePath(apiURL.getCommonCode.api, code)}`,
    {
      method: apiURL.getCommonCode.method,
      headers: headersMap,
    })
    return result;
  }

  const loadResource = async (uri) => {
    let query = `?uri=${uri}`
    fetch(`${SERVER_URL}${apiURL.baseUri}${apiURL.loadResource.api}${query}`,
    {
      method: apiURL.loadResource.method,
      headers: headersMap,
    }).then(res => {
      pictureRef.value = res;
    })
    .catch(err => {
      errorRef.value.message = res.error.msg
      console.log(err)
    })
  }

  return {
    pwd: passwdRef, error: errorRef, checkResponse:checkRes,
    checkPwd, loadCommonCode, loadResource, picture: pictureRef,
  }
}
export default commonApi